export const ALL_MAGNITUDE_SUFFIXES = ['K', 'M', 'B', 'T', 'Q'];
const MAX_DEFAULT_CHARS = 6;
const MAX_NUMBER_CHARS = MAX_DEFAULT_CHARS - 1;
const DIVISORS = {
    K: 1000,
    M: 1000000,
    B: 1000000000,
    T: 1000000000000,
    Q: 1000000000000000
};
function getDecimalNumberStr(rawDecimalNumberStr) {
    if (!rawDecimalNumberStr) {
        return '';
    }
    // remove trailing zeroes:
    while (rawDecimalNumberStr.endsWith('0')) {
        rawDecimalNumberStr = rawDecimalNumberStr.substring(0, rawDecimalNumberStr.length - 1);
    }
    return rawDecimalNumberStr;
}
/**
 * Takes a value intended for display of chips (whole numbers, non-negative) and shortens it to a max of 6 characters
 * (value string, plus optional one-character suffix for magnitude).
 */
export function getShortRenderedValue(value) {
    if (value <= 0) {
        return { valueStr: '0' };
    }
    value = Math.floor(value);
    const defaultValueStr = value.toLocaleString();
    if (defaultValueStr.length <= MAX_DEFAULT_CHARS) {
        return { valueStr: defaultValueStr };
    }
    for (let i = 0; i < ALL_MAGNITUDE_SUFFIXES.length; i++) {
        const suffix = ALL_MAGNITUDE_SUFFIXES[i];
        const divisor = DIVISORS[suffix];
        const [wholeNumberStr, rawDecimalNumberStr] = `${Math.floor((value / divisor) * 1000) / 1000}`.split('.');
        if (wholeNumberStr.length > 3) {
            // go up to next level
            continue;
        }
        const decimalNumberStr = getDecimalNumberStr(rawDecimalNumberStr);
        if (!decimalNumberStr) {
            // no decimal at all, or is only zeroes after the dot, only whole number matters
            return { valueStr: wholeNumberStr, suffix };
        }
        let valueStr = `${wholeNumberStr}.${decimalNumberStr}`;
        while (valueStr.length > MAX_NUMBER_CHARS) {
            valueStr = valueStr.substring(0, valueStr.length - 1);
        }
        // might still be trailing zeroes:
        while (valueStr.indexOf('.') !== -1 && valueStr.endsWith('0')) {
            valueStr = valueStr.substring(0, valueStr.length - 1);
        }
        if (valueStr.endsWith('.')) {
            valueStr = valueStr.substring(0, valueStr.length - 1);
        }
        return { valueStr, suffix };
    }
    // super large number, don't even bother trying any more
    return { valueStr: 'MAX' };
}
export function getShortRenderedValueStr(value) {
    const { valueStr, suffix } = getShortRenderedValue(value);
    if (!suffix) {
        return valueStr;
    }
    return `${valueStr}${suffix}`;
}
